import { marked } from 'marked';
import { useEffect, useRef } from 'react';

import { Text } from 'components/@tedui';
import Divider from 'components/divider';
import Markdown from 'components/markdown';

import { trackOutboundLinks } from 'lib/analytics/mixpanel-helpers';

import useVideoPlayerStore from 'components/video-player/store';
import RecommendationCardProps from './RecommendationCard.props';

const RecommendationCard = ({
  citation,
  title,
  description,
  label,
  linkUrl,
  showDivider
}: RecommendationCardProps) => {
  const linkRef = useRef(null);
  const autoplayed = useVideoPlayerStore(store => store.autoplayed);
  const formatLabel = (label: string): string => {
    let labelToFormat = label.toLowerCase();

    if (labelToFormat.includes('_')) {
      const splitLabels = labelToFormat.split('_');

      labelToFormat = splitLabels[1].toString();
    }

    const formattedLabel =
      labelToFormat.charAt(0).toUpperCase() + labelToFormat.slice(1);

    return formattedLabel;
  };

  const formatCitation = (text: string, label: string): string => {
    const citationLabel = `| ${label}`;
    const citation = marked.parse(text.replace('\r\n', ' | '));

    return `${citation} ${citationLabel}`;
  };

  const formattedLabel = formatLabel(label);
  const formattedTitle = marked.parse(title);

  useEffect(() => {
    if (linkRef.current) {
      trackOutboundLinks(
        linkRef.current,
        'speaker resource list',
        linkUrl,
        autoplayed
      );
    }
  }, []);

  return (
    <div className="flex flex-col">
      <div className="mb-2">
        <Text
          variant="caption"
          color={{
            override: '#555'
          }}
        >
          <span
            {...{
              dangerouslySetInnerHTML: {
                ...{ __html: formatCitation(citation, formattedLabel) }
              }
            }}
          />
        </Text>
      </div>

      <div className="mb-6">
        <a
          ref={linkRef}
          href={linkUrl}
          target="_blank"
          rel="noreferrer noopener"
        >
          <Text tag="span" variant="subheader2" isBold>
            <span dangerouslySetInnerHTML={{ __html: formattedTitle }} />
          </Text>
        </a>
      </div>

      {description !== '' && (
        <div className="mb-8 text-sm">
          <Markdown>{description}</Markdown>
        </div>
      )}

      {showDivider && <Divider className="mb-5" />}
    </div>
  );
};

export default RecommendationCard;
